export default __webpack_public_path__ + "static/media/skinke.d8623855.svg";